import { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { useTaskLevelQuestionnaire } from '../../../../modernization-common/provider/task-level-questionnaire';
import { taskQuestionnaireSyncAtom } from '../../atoms/qa-engine-atom';

/**
 * This component syncs the questionnaire values from external store to internal store. This is required as there is no other way to create derived atoms from different stores.
 */
export function TaskQuestionnaireSync() {
  const {
    atom: questionnaireAtom,
    store
  } = useTaskLevelQuestionnaire();
  const questionnaireValue = useAtomValue(questionnaireAtom, store ? {
    store
  } : undefined);
  const setTaskQuestionnaire = useSetAtom(taskQuestionnaireSyncAtom);
  useEffect(() => {
    setTaskQuestionnaire(questionnaireValue ?? undefined);
  }, [questionnaireValue, setTaskQuestionnaire]);
  return null;
}